











import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"
import {GetListByCode} from "@/api/configureDictionary"
import {GetDlyChargeStatistics} from "@/api/report"

@Component
export default class chargeStatistics extends AbpBase{
	sum = 0
	loading = false
	dateRange:any = []
	data:any = []
	selects:Array<any> = []
	materialTypeItem:any = []
	columns:any = []
	async created(){
		this.dateRange = this.getMonthStartAndEnd()
		await this.getSelects()
		this.getData()
	}

	private async getSelects() {
		let res = await GetListByCode({input: '010'})
		res.forEach((_:any, index:any)=>{
			this.materialTypeItem.push(index)
		})
		this.selects = res
	}

	private async getData() {
		this.loading = true
		this.columns = [
			{
				title: '日期',
				key: 'type'
			}
		]
		let sumLine:any = {
			type: '合计'
		}
		let query:any = {
			materialTypeItem:[],
			startDate: this.dateRange[0],
			endDate: this.dateRange[1]
		}
		this.materialTypeItem.forEach((item:number)=>{
			query.materialTypeItem.push(this.selects[item])
			sumLine[this.selects[item].text+'quantity'] = 0
			sumLine[this.selects[item].text+'amount'] = 0
			this.columns.push({
				title: this.selects[item].text,
				children:[
					{
						title: '数量',
						key: this.selects[item].text+'quantity'
					},
					{
						title: '金额',
						key: this.selects[item].text+'amount'
					}
				]
			})
		})
		let res = await GetDlyChargeStatistics(query)
		res.objects.chargeItem.forEach((item:any,index:number) => {
			item.chargeDetailItem.forEach((j:any) => {
				item[j.text + 'quantity'] = j.quantity
				item[j.text + 'amount'] = Number(j.amount).toFixed(2)

				sumLine[j.text + 'quantity'] += Number(j.quantity)
				sumLine[j.text + 'amount'] += Number(Number(j.amount).toFixed(2))

			})
			if (index === res.objects.chargeItem.length-1){
				Object.keys(sumLine).forEach((item:any) => {
					if (/^\d+$/.test(sumLine[item])  && item.indexOf('amount') !== -1) {
						sumLine[item] = sumLine[item].toFixed(2)
					}
				})
			}
		})
		this.data = [...res.objects.chargeItem, sumLine]
		this.sum = res.objects.totalAmount
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/chargeStatistics/index.vue